import { ON_WIDGET_OPEN_EVENT, ON_WIDGET_CLOSE_EVENT } from 'app/constants/events'

export const triggerEvent = (eventType, data) => {
  const detail = data || ''
  const event = new CustomEvent(eventType, { detail })

  window.dispatchEvent(event)
  window.parent.dispatchEvent(event)
}

/**
 * this function triggers open,close event based on widget's new status
 * @param {boolean} newStatus
 */
export const triggerWidgetOpenCloseEvent = (newStatus) => {
  const eventName = newStatus ? ON_WIDGET_OPEN_EVENT : ON_WIDGET_CLOSE_EVENT

  // trigger open widget event when user opens it
  triggerEvent(eventName, true)
}
